import React from 'react';

interface LogoProps {
  src: string;
  alt: string;
  width: number;
  height: number;
}

const Logo = ({ src, alt, width, height }: LogoProps) => (
  <img 
    src={src} 
    alt={alt} 
    style={{ width: `${width}px`, height: `${height}px` }}
    className="object-contain transition-all duration-300"
  />
);

export default Logo;